import { useState } from "react";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import SelectSingleServiceModuleDialog from "../../../serviceModules/SelectSingleServiceModuleDialog";
import { GeneralButton } from "../../../../common/ui/GeneralButton";

export function LinkServiceModuleEditor(props: PropertyEditorProps) {
    const [open, setOpen] = useState(false);

    return <>
        <GeneralButton
            appVariant="secondary"
            onClick={() => setOpen(true)}>
            Servicemodul wählen
        </GeneralButton>
        {
            open &&
            <SelectSingleServiceModuleDialog
                onClose={() => setOpen(false)}
                selectedModule={(props.value ?? null) as number | null}
                handleOnSave={(id) => {
                    setOpen(false);
                    props.onChanged(id);
                }}
            />
        }
    </>;
}